import React, { useMemo } from 'react';
// @ts-ignore ts declaration have`t emptyRenderer, but it exists
import { emptyRenderer } from 'react-table';
import { Table, TableBody, TableBodyRow, TableBodyRowExpanded, TableFooter, TableHead, TableLoading } from './components';
import { TableLayoutContextProvider } from './layout-context';
import { TableWrapper } from './styled';
export function TableLayout({ tableInstance, className, additionalProps, bottom, hasTop, renderRowSubComponent: RowSubComponent, onRowClick, errorComponent: ErrorComponent, noDataComponent: NoDataComponent, layoutType = 'table', isLoading }) {
    const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page, selectedFlatRows, footerGroups, state, allColumns } = tableInstance;
    /*   const customScrollProps = useMemo(() => {
      if (!maxHeightTable) return {};
      return { autoHeight: true, autoHeightMax: maxHeightTable };
    }, [maxHeightTable]); */
    const hasFooter = useMemo(() => allColumns.some((column) => {
        // https://github.com/TanStack/table/issues/2983
        // @ts-ignore
        return column.Footer !== null && column.Footer !== emptyRenderer;
    }), [allColumns]);
    // This hook calculates the number of virtual columns in the table.
    const virtualColumnsCount = useMemo(() => {
        return tableInstance.allColumns.reduce((acc, column) => {
            if (column.isVirtualColumn) {
                return acc + 1;
            }
            return acc;
        }, 0);
    }, [tableInstance.allColumns]);
    // This filters the footer groups to only include those with headers that have a Footer.
    const footerGroupsForRender = footerGroups.filter((group) => group.headers.some((header) => header.Footer));
    let fallbackContent = null;
    if (isLoading) {
        fallbackContent = React.createElement(TableLoading, { headerGroups: headerGroups });
    }
    else if (ErrorComponent) {
        fallbackContent = (React.createElement(TableBodyRowExpanded, { colSpan: tableInstance.visibleColumns.length }, ErrorComponent));
    }
    else if (NoDataComponent && page.length === 0) {
        // Check for no data condition
        fallbackContent = (React.createElement(TableBodyRowExpanded, { colSpan: tableInstance.visibleColumns.length }, NoDataComponent));
    }
    return (React.createElement(TableLayoutContextProvider, { value: layoutType },
        React.createElement(TableWrapper, { "$hasTop": hasTop, className: "invent-table-wrapper" },
            React.createElement(Table, { layoutType: layoutType, className: className, ...getTableProps() },
                React.createElement(TableHead, { headerGroups: headerGroups, selectedRowIds: state.selectedRowIds, props: additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.header, selectedFlatRows: selectedFlatRows }),
                React.createElement(TableBody, { ...getTableBodyProps() }, fallbackContent
                    ? fallbackContent
                    : page.map((row) => {
                        prepareRow(row);
                        const rowProps = row.getRowProps();
                        return (React.createElement(React.Fragment, { key: rowProps.key },
                            React.createElement(TableBodyRow, { ...rowProps, row: row, props: additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.cell, selectedRowIds: state.selectedRowIds, onRowClick: onRowClick }),
                            row.isExpanded && RowSubComponent ? (React.createElement(TableBodyRowExpanded, { colSpan: tableInstance.visibleColumns.length - 1 + virtualColumnsCount },
                                React.createElement(RowSubComponent, { row: row, tableInstance: tableInstance }))) : null));
                    })),
                React.createElement(TableFooter, { hasFooter: hasFooter, bottom: bottom, colSpan: tableInstance.visibleColumns.length, footerGroups: footerGroupsForRender, props: additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.footer })))));
}
